export default __webpack_public_path__ + "tmp_src/components/ImgZoom/ImgZoom.css.liquid";